import Component from 'flarum/common/Component';
import Stream from 'flarum/utils/Stream';

import getUserInfo from "../common/util/getUserInfo";
import itemColor from "../common/util/itemColor";
import getDaysDifferent from "../common/util/getDaysDifferent";
import UserSubmitModal from './modal/UserSubmitModal';
import distributeRatio from '../common/util/distributeRatio';
import estimateIncome from '../common/util/estimateIncome';
import getItemUnit from "../common/util/getItemUnit";
import infoPromotionImageModal from './modal/infoPromotionImageModal';
import playVideoModal from "./modal/playVideoModal";

export default class DistributeType0ListItem extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    const distributeData = this.attrs.distributeData;
    this.distributeData = distributeData;
    this.distributeID = distributeData.id();
    this.infoDetailsData = distributeData.u2diDetailsData();
    this.infoBaseData = distributeData.u2diBaseData();
    this.loading = false;
  }

  view() {
    this.infoID = this.infoBaseData.id();
    this.infoSN = this.infoBaseData.sn();
    this.infoCategory = this.infoBaseData.category();
    this.infoType = this.infoBaseData.type();
    this.itemColor = itemColor(this.infoType);
    this.infoTypeText = app.translator.trans("ziven-u2di.forum.option-zclb-"+this.infoType);

    this.info_zcxx = JSON.parse(this.infoDetailsData.zcxx());
    this.info_ghtj = JSON.parse(this.infoDetailsData.ghtj());
    this.info_jjxx = JSON.parse(this.infoDetailsData.jjxx());
    this.info_lxxx = {};
    
    const infoUserType = this.infoBaseData.userType();
    const infoProvince = this.infoBaseData.province();
    const infoCity = this.infoBaseData.city();
    const infoPrice = this.infoBaseData.price();
    const infoFlag = this.infoBaseData.flag();
    const infoPriceUnit = getItemUnit(this.infoCategory,this.info_jjxx);
    const infoNid = this.distributeData.nID();
    const infoSignedMark = this.infoBaseData.signedMark();

    const showNew = daysDifferents<=3 && infoStatus===0;
    const unreadStyle = showNew?"margin-left:40px":"";

    let userID = this.infoBaseData.userID();
    let itemLatModifier = 0;
    let itemLngModifier = 0;
    const u2diUserType9 = app.forum.attribute('u2diUserType9');

    if((app.session.user && userID==app.session.user.id()) || u2diUserType9===true || infoFlag===1){
      let userInfo = getUserInfo(app.session.user.id())
      let assignedAt = userInfo.assignedAt();
      let key = (this.infoSN%5)*2+1;

      itemLatModifier=(assignedAt[key]/10/100);
      itemLngModifier=(assignedAt[key+1]/10/100);
    }

    this.infoLocationText = (infoProvince && infoProvince!==infoCity?infoProvince:"")+""+infoCity;
    this.position = {
      lng: this.distributeData.lng()+itemLatModifier,
      lat: this.distributeData.lat()+itemLngModifier
    };
    
    const infoStatus = this.infoBaseData.status();
    const infoBottomStyle = infoStatus===0?"background: rgba("+this.itemColor+",.7)":"background:gray";
    const infoIcon = infoFlag===1?"fas fa-home":(this.infoCategory==="jzwz"?"fas fa-city":"fas fa-th-large");
    const infoDistributes = this.infoBaseData.distributes();
    const infoEstimateIncome = estimateIncome(this.infoBaseData,this.infoDetailsData);
    const assignedAt = this.distributeData.assignedAt();
    const daysDifferents = getDaysDifferent(new Date().toISOString(),assignedAt);
    const bilibiliLink = this.infoBaseData.bilibiliLink();

    return (
      <div className="u2diInfoItemContainer">
        {window.selectedCategory==="rrrrrrr" && window.selectedTargetID===this.distributeID && (
          <div className="u2diInfoIndicator"></div>
        )}
        
        <div className="u2diManageSideBarInfoData" onclick={(e) => { this.locateInfoOnMap() }}>
          <div style="padding-top: 5px;">
            <div className="u2diManageSideBarInfoRow1">
              <span style={infoStatus===2?"color:gray !important":"color: rgba("+this.itemColor+") !important"}><i className={infoIcon}></i></span>
              <span style="position:relative;">
                {this.infoSN}
                
                {showNew && (
                  <div className="u2diListItemLabel">
                    <div className="u2diLabelRed">NEW</div>
                  </div>
                )}

                {infoNid===null && (
                  <div style={unreadStyle} className="u2diListItemLabel">
                    <div style="padding:0px 5px;" className="u2diLabelOrange">{app.translator.trans('ziven-u2di.forum.item-unread')}</div>
                  </div>
                )}
              </span>
              <span>
                <div style="display:inline-block">{this.infoTypeText}</div>
                {infoSignedMark===1 && (
                  <div style="margin-left: 5px;width: 14px;font-size: 14px;">
                    <i style="color: #04aa41;" class="fas fa-check-circle"></i>
                  </div>
                )}
                {bilibiliLink && (
                  <div style="cursor:pointer;margin-left: 5px;font-size: 14px;" onclick={(e)=>{e.preventDefault();e.stopPropagation();app.modal.show(playVideoModal,{link:bilibiliLink})}}>
                    <i style="margin-right: 5px;color: #00A1D6;" class="fas fa-play-circle"></i>
                  </div>
                )}
              </span>

              {infoStatus===0 && (
                <span className={"u2diListItemStatus"+infoStatus}>{infoPrice} <span style="color: gray;font-size: 12px;">{infoPriceUnit}</span></span>
              )}

              {infoStatus!==0 && (
                <span className={"u2diListItemStatus"+infoStatus}>{app.translator.trans('ziven-u2di.forum.item-status-'+infoStatus)}</span>
              )}
            </div>
            <div className="u2diManageSideBarInfoRow2">
              <span className="u2diEllipsisArea">{this.infoLocationText}</span>
            </div>
          </div>
        </div>
        <div style="display: flex;border-left: 1px solid rgba(122, 122, 122, 0.2);border-right: 1px solid rgba(122, 122, 122, 0.2);padding: 4px 10px;background: rgb(221, 221, 221);align-items: center;">
          <div style="display: inline-block;width: 73px;color: gray;font-size: 12px;">
            <div>{app.translator.trans('ziven-u2di.forum.item-estimate-income')}</div>
            <div>
                <span style="font-size: 18px;color: black;">{infoEstimateIncome}</span> <span>{app.translator.trans('ziven-u2di.lib.unit-10k')}</span>
            </div>
          </div>
          <div style="display:inline-block;">{distributeRatio(infoUserType)}</div>
        </div>
        
        {infoStatus===0 && (
          <div id={"u2diManageSideBarInfoBottom"+this.infoID} style={infoBottomStyle} className="u2diManageSideBarInfoBottomData">
            <div style="text-align: left;display: flex;">
              {app.translator.trans('ziven-u2di.forum.item-distribute-info',{distributes:infoDistributes})}
            </div>
            <div style="text-align: right;">
              <span style="margin-right:10px;cursor:pointer" onclick={(e) => { app.modal.show(infoPromotionImageModal,{infoID:this.infoID}) }}>{app.translator.trans('ziven-u2di.forum.item-generate-promotion-image')}</span>
              <span style="cursor:pointer" onclick={(e) => { this.viewDetails() }}>{app.translator.trans('ziven-u2di.forum.item-details')}</span>
            </div>
          </div>
        )}
        
        {infoStatus!==0 && (
          <div id={"u2diManageSideBarInfoBottom"+this.infoID} style={infoBottomStyle} className="u2diManageSideBarInfoBottomData">
            <div style="text-align: left;display: flex;">
              {app.translator.trans('ziven-u2di.forum.item-distribute-info',{distributes:infoDistributes})}
            </div>
            <div style="text-align: right;width: 170px;">
            </div>
          </div>
        )}
      </div>
    );
  }

  locateInfoOnMap(){
    $(window).trigger('u2diLocateInfoOnMap', {
      position : new AMap.LngLat(this.position.lng,this.position.lat),
      itemID: this.infoID,
      targetID:this.distributeID,
      dataType: "distribute"
    });
  }

  viewDetails(){
    const wrapData = {
      selectedType:this.infoCategory,
      initType:"resume",
      viewType:"read",
      from:"distribute",
      targetData: this.infoBaseData,
      reports:this.infoBaseData.reports(),
      option_zcqs: Stream(this.info_zcxx.option_zcqs),
      option_lzxz: Stream(this.info_zcxx.option_lzxz),
      option_lzxz_checked: Stream(this.info_zcxx.option_lzxz_checked),
      option_zclb: Stream(this.info_zcxx.option_zclb),
      option_zcwz: Stream(this.info_zcxx.option_zcwz),
      option_tdmj: Stream(this.info_zcxx.option_tdmj),
      option_jzmj: Stream(this.info_zcxx.option_jzmj),
      option_jzmj_disabled:Stream(this.info_zcxx.option_jzmj_disabled),
      option_synx: Stream(this.info_zcxx.option_synx),
      option_zcdb: Stream(this.info_zcxx.option_zcdb),
      option_zpzl: Stream(this.info_zcxx.option_zpzl),
      option_ystd: Stream(this.info_zcxx.option_ystd),

      option_ghtj: Stream(this.info_ghtj.option_ghtj),
      option_wjzl: Stream(this.info_ghtj.option_wjzl),
      option_ydmj: Stream(this.info_ghtj.option_ydmj),
      option_rjl: Stream(this.info_ghtj.option_rjl),
      option_ldl: Stream(this.info_ghtj.option_ldl),
      option_jzmd: Stream(this.info_ghtj.option_jzmd),
      option_jzxg: Stream(this.info_ghtj.option_jzxg),
      option_jzxg_disabled: Stream(this.info_ghtj.option_jzxg_disabled),

      // option_ysx: Stream(this.info_jjxx.option_ysx),
      // option_cjjg: Stream(this.info_jjxx.option_cjjg),
      option_crxs: Stream(this.info_jjxx.option_crxs),
      option_ssyq: Stream(this.info_jjxx.option_ssyq),
      option_ssyq_checked: Stream(this.info_jjxx.option_ssyq_checked),
      option_ysdj: Stream(this.info_jjxx.option_ysdj),
      option_yqjg: Stream(this.info_jjxx.option_yqjg),
      option_jjbl: Stream(this.info_jjxx.option_jjbl),
      option_zsyq: Stream(this.info_jjxx.option_zsyq),

      option_lxxx: Stream(this.info_lxxx.option_lxxx),
      option_bmqy: Stream(this.info_lxxx.option_bmqy),
      option_zjgw: Stream(this.info_lxxx.option_zjgw),
      option_zsxm: Stream(this.info_lxxx.option_zsxm),
      option_zsxm_title: Stream(this.info_lxxx.option_zsxm_title),
      option_lxdh: Stream(this.info_lxxx.option_lxdh),
      option_lxdh_checked: Stream(this.info_lxxx.option_lxdh_checked),
      option_lxdh_wx_value: Stream(this.info_lxxx.option_lxdh_wx_value),
      option_lxdh_wx_value_disabled: Stream(this.info_lxxx.option_lxdh_wx_value_disabled),
    };

    app.modal.show(UserSubmitModal,{wrapData});
  }
}